import { bool, node, func } from "prop-types";

const propTypes = {
  children: node,
  disabled: bool,
  checked: bool,
  onChange: func,
};

const Checkbox = (props) => {
  const { children, disabled, checked, onChange, ...otherProps } = props;

  return (
    <label className="checkbox" {...otherProps}>
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />{" "}
      <span className="checkbox__custom"></span> {children}
    </label>
  );
};

Checkbox.propTypes = propTypes;
export default Checkbox;
